import '@material/web/icon/icon.js'
import '@operato/dataset/ox-data-sample-view.js'
import '@operato/dataset/ox-checklist-sample-view.js'
import gql from 'graphql-tag'
import { css, html, LitElement } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'

import { client } from '@operato/graphql'
import { i18next, localize } from '@operato/i18n'
import { ScrollbarStyles } from '@operato/styles'

@customElement('activity-ooc-review-edit')
class OocReviewActivityEdit extends localize(i18next)(LitElement) {
  static styles = [
    ScrollbarStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;

        background-color: var(--md-sys-color-surface);
      }

      div[content] {
        flex: 1;
        flex-direction: column;

        display: flex;
        overflow: auto;
      }

      ox-data-sample-view,
      ox-checklist-sample-view {
        flex: 1;
        padding: var(--spacing-large);
        overflow: auto;
      }

      label[instruction] {
        display: flex;
        flex-direction: column;

        padding: var(--spacing-large);

        h2 {
          display: flex;

          color: var(--title-text-color);
          text-transform: capitalize;
          margin: var(--title-margin);
          align-items: center;
        }

        div {
          padding: var(--spacing-large);
          font: var(--input-field-font);
        }

        md-icon {
          color: var(--status-danger-color);
        }

        textarea {
          border: var(--input-field-border);
          border-radius: var(--spacing-small);
          margin: var(--spacing-medium);
          padding: var(--spacing-medium);
          font: var(--input-field-font);
          color: var(--md-sys-color-on-surface);
          background: var(--md-sys-color-surface-variant);

          resize: none;
          outline: none;
          min-height: 200px;
        }
      }
    `
  ]

  @property({ type: Object }) input?: any
  @property({ type: Object }) output?: any
  @property({ type: Object }) activityThread?: any

  @state() dataOoc?: any

  render() {
    const instruction = this.output?.instruction
    const { state } = this.activityThread || {}
    const editable = state == 'unassigned' || state == 'assigned' || state == 'started' || state == 'submitted'

    return html`
      <div content>${this.renderDataSample()}</div>

      <label instruction>
        <h2><md-icon>build_circle</md-icon>&nbsp;<span>${i18next.t('label.corrective instruction')}</span></h2>
        ${editable
          ? html`
              <textarea
                placeholder=${String(i18next.t('text.corrective instruction placeholder'))}
                .value=${instruction || ''}
                @change=${this.onChangeInstruction}
              ></textarea>
            `
          : html`<div>${instruction}</div>`}
      </label>
    `
  }

  onChangeInstruction(e: Event) {
    this.output ||= {}
    this.output.instruction = (e.target as HTMLTextAreaElement).value

    this.dispatchEvent(
      new CustomEvent('change', {
        detail: this.output
      })
    )
  }

  updated(changes) {
    if (changes.has('input')) {
      this.fetchDataOoc()
    }
  }

  async fetchDataOoc() {
    const id = this.input?.dataOocId

    if (id) {
      const response = await client.query({
        query: gql`
          query ($id: String!) {
            dataOoc(id: $id) {
              id
              name
              description
              ooc
              oos
              state
              type
              useCase
              data
              judgment
              dataSet {
                id
                name
                monitorType
                monitorView
              }
              dataItems {
                name
                description
                active
                hidden
                tag
                group
                subgroup
                type
                unit
                options
                quota
                spec
                stat
              }
              workDate
              workShift
              collectedAt
            }
          }
        `,
        variables: {
          id
        }
      })

      this.dataOoc = response.data.dataOoc
    }
  }

  private renderDataSample() {
    const dataSet = this.dataOoc?.dataSet
    const monitorType = dataSet?.monitorType

    switch (monitorType) {
      case 'generated':
        return html`<ox-data-sample-view .dataSample=${this.dataOoc}></ox-data-sample-view>`
      case 'checklist':
        return html`<ox-checklist-sample-view .dataSample=${this.dataOoc}></ox-checklist-sample-view>`
      case 'board':
        break
      case 'page':
        break
      default:
        return html`<ox-data-sample-view .dataSample=${this.dataOoc}></ox-data-sample-view>`
    }
  }
}
